import styled from 'styled-components';

export const ContinueContainer = styled.div`
  /* width: var(--sizing-4xl); */
  /* Keeping this for future development work */
`;
